import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getCustomers = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/customers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getMyCustomers = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/customers/misclientes`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const addCustomer = async (customer) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(`${API_URL}/customers`, customer, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getCustomerById = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/customers/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateCustomer = async (id, updatedCustomer) => {
  const token = localStorage.getItem("token");

  // Convierte marcas en cadena separada por comas si es un array
  if (Array.isArray(updatedCustomer.marcas)) {
    updatedCustomer.marcas = updatedCustomer.marcas.join(", ");
  }

  const response = await axios.put(
    `${API_URL}/customers/${id}`,
    updatedCustomer,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const deleteCustomer = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/customers/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getContactsByCustomerId = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/contacts`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const addContact = async (customerId, contact) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/contacts`,
    contact,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateContact = async (id, contact) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/contacts/${id}`, contact, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteContact = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/contacts/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getActivitiesByCustomerId = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/activities`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const addActivity = async (customerId, activity) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/activities`,
    activity,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateActivity = async (id, activity) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/activities/${id}`, activity, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteActivity = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/activities/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getEmails = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/emails`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const addEmail = async (customerId, email) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/emails`,
    email,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateEmail = async (id, email) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/emails/${id}`, email, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteEmail = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/emails/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const uploadExcelFile = async (formData) => {
  const response = await axios.post("/api/upload-excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getMarcasClient = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/marcas`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateMarcas = async (customerId, marcas) => {
  const token = localStorage.getItem("token");

  const response = await axios.put(
    `${API_URL}/customers/${customerId}/marcas`,
    { marcas },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

/* presupuestos */
export const getClientes = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/clientes`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
